import { useCallback, useMemo } from 'react';
import { useApi, storageApiRef } from '@backstage/core-plugin-api';

const STORAGE_KEY = 'grafana-dashboard/refresh-interval';
const DEFAULT_INTERVAL = 30000;

/** Available refresh interval options (ms) */
export const REFRESH_INTERVALS = [
  { label: '10s', value: 10_000 },
  { label: '30s', value: 30_000 },
  { label: '1m', value: 60_000 },
  { label: '5m', value: 300_000 },
  { label: 'Off', value: 0 },
] as const;

/**
 * Reads and writes the observability refresh interval from
 * Backstage's per-user StorageApi (persisted in localStorage).
 */
export function useRefreshInterval() {
  const storageApi = useApi(storageApiRef);
  const bucket = useMemo(
    () => storageApi.forBucket('settings'),
    [storageApi],
  );

  const snapshot = bucket.snapshot<number>(STORAGE_KEY);
  const interval = snapshot.value ?? DEFAULT_INTERVAL;

  const setInterval_ = useCallback(
    (ms: number) => {
      bucket.set(STORAGE_KEY, ms);
    },
    [bucket],
  );

  return { interval, setInterval: setInterval_ };
}
